<template>
  <div class="popup-store" :class="{ 'active': open }">
    <div class="popup__backdrop" @click="closePopup"></div>
    <div class="popup__box">
      <div class="close" @click="closePopup"><span class="fi-rr-cross"></span></div>
      <div class="popup-head">
        <div class="title">
          <h3>Choisir ma boutique Welcom</h3>
          <p>Sélectionnez une boutique où votre téléphone est disponible</p>
        </div>
        <div class="geolocation" @click.prevent="triggerGeolocation">
          <div class="inner">
            <div class="icon"><span class="fi-rr-geolocation"></span></div>
            <div class="text"><p>Choisir un magasin <br/>ou <a href="" class="get-location">me géolocaliser</a></p></div>
            <div class="text-mobile"><p><a href="" class="get-location">me géolocaliser</a></p></div>
          </div>
        </div>
        <div class="search-input">
          <SearchPlace @selected="refreshStores"/>
        </div>
      </div>
      <div class="popup-stock-only">
        <CheckBox v-model="stockOnly" label="Magasins avec stock uniquement"/>
      </div>
      <div class="stores">
        <div class="loader" v-if="loading"><SmallLoader/></div>
        <perfect-scrollbar :options="scrollbarOptions">
          <div class="store" :class="{ 'first': (index === 0)}" v-for="(store, index) in customStores" :key="store.code" @click.prevent="selectStore(store)">
            <div class="logo"><span class="fi-rr-welcom"></span></div>
            <div class="data">
              <div>
                <div class="name"><h4><span class="fi-rr-welcom"></span>{{ store.name }}</h4></div>
                <div class="opening-status">
                  <p v-if="store.openingStatus === 'closed'"><span :class="[store.openingStatus]">Fermé</span> {{ store.openingSentence }}</p>
                  <p v-else><span :class="[store.openingStatus]">Ouvert</span> {{ store.openingSentence }}</p>
                </div>
              </div>
            </div>
            <div class="stock">
              <div class="stock-data in-stock" v-if="store.stock > limited && !stockLoading"><p><span class="fi-rr-check"></span>En stock</p></div>
              <div class="stock-data limited-stock" v-else-if="store.stock > 0 && store.stock <= limited && !stockLoading"><p><span class="fi-rr-check"></span>Stock limité</p></div>
              <div class="stock-data out-of-stock" v-else-if="store.stock <= 0 && !stockLoading"><p><span class="fi-rr-cross"></span>Indisponible</p></div>
              <div class="stock-data stock-data-loader" v-else>
                <SmallLoader :primary="true" :relative="true"/>
              </div>
            </div>
            <div class="select">
              <a href=""><span class="fi-rr-arrow-small-right"></span></a>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import CheckBox from './CheckBox'
import SmallLoader from './SmallLoader'
import SearchPlace from './SearchPlace'

import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'StorePopup',
  data () {
    return {
      scrollbarOptions: {
        wheelPropagation: false,
        suppressScrollX: true
      },
      stockOnly: false
    }
  },
  computed: {
    ...mapState({
      selectedCode: state => state.stores.selected,
      open: state => state.stores.popup,
      stores: state => state.stores.items,
      loading: state => state.stores.loading,
      limited: state => state.stores.limited,
      phone: state => state.phone.item,
      stockLoading: state => state.stores.stockLoading
    }),
    customStores () {
      const stores = []

      if(this.stockOnly) {
        this.stores.forEach((store) => {
          if(store.stock){
            stores.push(store)
          }
        })
      } else {
        this.stores.forEach((store) => {
          stores.push(store)
        })
      }

      return stores
    }
  },
  methods: {
    ...mapActions('stores', ['closePopup', 'setStore', 'getStores', 'getStocks']),
    selectStore (store) {
      this.closePopup()
      this.setStore(store.code)
      this.$emit('updatePhone')
    },
    triggerGeolocation() {
      const geolocationLink = document.querySelector('header.main-header .head .actions .stores .store-selector .selector-map a.geolocation')
      if (geolocationLink) geolocationLink.click()
      this.closePopup()
    },
    refreshStores (coordinates) {
      this.getStores({
        geolocation: coordinates
      }).then(() => {
        this.getStocks({ packID: this.phone.packId })
      })
    }
  },
  components: {
    CheckBox,
    SmallLoader,
    SearchPlace,
    PerfectScrollbar
  }
}
</script>

<style src="vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css"/>
<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.popup-store{
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
  height: 100vh;
  width: 100vw;
  overflow: scroll;

  @include responsive(mobile) {
    padding: 20px;
    background-color: rgba($black, 0.9);
  }

  &.active{
    display: block;

    @include responsive(mobile) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .popup__backdrop{
    background-color: rgba($black, 0.9);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;

    @include responsive(mobile) {
      display: none;
    }
  }

  .popup__box{
    max-width: 1050px;
    background-color: $primary;
    padding: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    @include transform(translateX(-50%) translateY(-50%) translateZ(0));
    @include radius(10px);

    @include responsive(mobile) {
      top: initial;
      left: initial;
      padding: 20px;
      position: relative;
      @include transform(translateX(0) translateY(0) translateZ(0));
    }

    .close {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 10px;
      right: 10px;
      text-align: center;
      line-height: 42px;
      color: $white;
      cursor: pointer;
      padding-left: 1px;
      @include radius(100%);
      @include transition();

      &:hover {
        background-color: rgba($black, 0.2);
      }
    }

    .popup-head{
      display: grid;
      grid-template-columns: 1fr auto 250px;
      grid-column-gap: 20px;
      margin-bottom: 10px;
      padding-right: 20px;

      @include responsive(mobile) {
        grid-template-columns: 1fr;
        padding-right: 0;
      }
    }

    .popup-stock-only{
      margin-bottom: 20px;
    }

    .title {
      margin-bottom: 20px;

      h3 {
        display: inline-block;
        color: $white;
        font-family: $headingsFont;
        line-height: px2rem(35px);
        font-size: px2rem(28px);
        margin-bottom: 5px;

        @include responsive(mobile) {
          line-height: px2rem(23px);
          font-size: px2rem(16px);
        }
      }

      p{
        color: rgba($white, 0.6);
        line-height: px2rem(20px);
      }
    }

    .search-input{
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .geolocation{
      display: flex;
      align-items: center;
      justify-content: center;
      width: auto;
      cursor: pointer;

      @include responsive(mobile){
        justify-content: flex-start;
        margin-bottom: 10px;
      }

      .inner{
        display: grid;
        grid-template-columns: auto 1fr;
        grid-column-gap: 20px;

        @include responsive(tablet){
          grid-column-gap: 10px;
          grid-template-columns: auto auto;
          width: auto;
        }

        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 26px;
          color: $white;

          @include responsive(mobile){
            font-size: 20px;
          }

          span {
            display: inline-block;
            vertical-align: middle;
            @include transform(translateY(-2px));
          }
        }

        .text, .text-mobile {
          p {
            color: $white;
            font-size: px2rem(14px);
            line-height: px2rem(21px);
            margin-bottom: 0;

            @include responsive(mobile){
              font-size: px2rem(13px);
              line-height: px2rem(18px);
            }

            a {
              color: $white;
              font-weight: $fontBold;
            }
          }
        }

        .text-mobile{
          display: none;

          @include responsive(mobile){
            display: block;
          }
        }

        .text{
          @include responsive(mobile){
            display: none;
          }
        }
      }
    }

    .stores{
      height: 355px;
      position: relative;

      .loader{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $primary;
        z-index: 100;
      }

      .store{
        display: grid;
        grid-template-columns: 84px 1fr auto 46px;
        background-color: $white;
        padding: 20px;
        margin-top: 10px;
        position: relative;
        cursor: pointer;
        @include radius(5px);

        @include responsive(mobile) {
          display: block;
          padding: 15px;
        }

        &.first{
          margin-top: 0;
        }

        &:hover{
          .select{
            a{
              background-color: $black;
            }
          }
        }

        a.link{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .logo {
          display: flex;
          align-items: center;
          justify-content: center;
          color: $primary;
          font-size: 50px;
          padding-right: 20px;

          @include responsive(mobile) {
            display: none;
          }
        }

        .data {
          display: flex;
          align-items: center;

          .name {
            margin-bottom: 5px;

            h4 {
              font-size: px2rem(16px);
              font-weight: $fontRegular;
              line-height: px2rem(21px);

              span{
                display: none;

                @include responsive(mobile){
                  display: inline-block;
                  margin-right: 5px;
                  vertical-align: middle;
                  font-size: 20px;
                  color: $primary;
                  @include transform(translateY(-2px));
                }
              }
            }
          }

          .opening-status{
            margin-bottom: 5px;

            p{
              font-size: px2rem(13px);
              line-height: px2rem(20px);
              color: $black;
              @include transition();

              span{
                display: inline-block;
                position: relative;

                &.closed{
                  color: #f62147;

                  &:before{
                    background-color: #f62147;
                  }
                }

                &.opened{
                  color: #5CD414;

                  &:before{
                    background-color: #5CD414;
                  }
                }

                &:after{
                  display: inline-block;
                  content: '-';
                  color: darken($white, 45%);
                  margin: 0 5px;
                  vertical-align: middle;
                }

                &:before{
                  display: inline-block;
                  content: '';
                  width: 9px;
                  height: 9px;
                  background-color: #f62147;
                  vertical-align: middle;
                  margin-right: 5px;
                  @include radius(100%);
                }
              }
            }
          }
        }

        .stock{
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
          padding-right: 20px;
          padding-left: 20px;
          text-align: right;

          @include responsive(mobile) {
            padding: 0;
            text-align: left;
            padding-top: 10px;
            margin-top: 10px;
            border-top: 1px solid darken($white, 5%);
          }

          p{
            margin: 0;
          }

          .stock-data-loader{
            padding-right: 20px;

            @include responsive(mobile) {
              padding: 20px 10px 10px 10px;
            }
          }

          .stock-data{
            font-size: px2rem(13px);

            &.in-stock{
              color: $greenValidate;
            }

            &.limited-stock{
              color: #f69956;
            }

            &.out-of-stock{
              color: #f62147;
            }

            p{
              span{
                display: inline-block;
                width: 10px;
                height: 10px;
                margin-right: 10px;
                vertical-align: middle;
                @include transform(translateY(-3px));
                @include radius(100%);

                &.fi-rr-cross{
                  font-size: px2rem(12px);
                  @include transform(translateY(-1px));
                }
              }
            }
          }
        }

        .select {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-right: 10px;

          @include responsive(mobile){
            display: none;
          }

          a {
            display: inline-block;
            width: 32px;
            height: 32px;
            background-color: $primary;
            color: $white;
            text-align: center;
            line-height: 35px;
            font-size: 24px;
            @include radius(100%);
            @include transition();

            @include responsive(mobile) {
              position: absolute;
              top: 50%;
              right: -16px;
              margin-top: -16px;
              background-color: $white;
              color: $primary;
              border: 1px solid $primary;

              &:hover, &:active, &:focus{
                background-color: $white;
                color: $primary;
                border: 1px solid $primary;
              }
            }

            span {
              display: inline-block;
              @include transform(translateX(1px));
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.popup-store{
  .popup__box{
    .stores{
      .ps{
        height: 355px;
        padding-right: 20px;

        @include responsive(mobile) {
          padding-right: 0;
        }

        .ps__rail-y{
          width: 6px;
          opacity: 0.7;
          margin: 0;

          &:hover, &.ps--clicking{
            background: none;
            opacity: 1;

            .ps__thumb-y{
              width: 6px;
            }
          }

          .ps__thumb-y{
            background-color: rgba(black, 0.5);
            right: 0;
          }
        }
      }
    }
  }
}
</style>
